import React from 'react';
import { FadeIn } from './FadeIn';
export function CostComparisonSection() {
  const costs = [{
    without: 'Noches de insomnio revisando el teléfono',
    cost: 'Tu salud mental y tu descanso'
  }, {
    without: 'Mensajes escritos desde la ansiedad',
    cost: 'Él se aleja más cada vez'
  }, {
    without: '"Contacto cero" mal aplicado',
    cost: 'La conexión se muere sola'
  }, {
    without: 'Consultas con videntas o amarres costosos',
    cost: '$50.000+ con resultados inciertos'
  }, {
    without: 'Otro mes sola esperando una señal',
    cost: 'Un mes de tu vida que no vuelve'
  }, {
    without: 'El mismo patrón en la próxima relación',
    cost: 'El dolor se repite con otra cara'
  }];
  return <section className="py-16 px-4 bg-miel-darker relative border-t border-miel-crimson/10" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <FadeIn data-id="element-13">
          <div className="text-center mb-10" data-id="element-14">
            <div className="text-4xl mb-4" data-id="element-15">⚖️</div>
            <h2 className="font-playfair text-3xl md:text-4xl text-miel-cream mb-4" data-id="element-16">
              ¿CUÁNTO CUESTA{' '}
              <span className="text-miel-crimson italic" data-id="element-17">NO TENERLO?</span>
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-18">
          <div className="bg-miel-dark rounded-2xl border border-miel-crimson/20 overflow-hidden shadow-2xl mb-16" data-id="element-19">
            <div className="grid grid-cols-2 bg-miel-crimson/10 border-b border-miel-crimson/20" data-id="element-20">
              <div className="p-4 md:p-6 font-playfair text-miel-cream/80 font-bold text-sm md:text-lg text-center border-r border-miel-crimson/20" data-id="element-21">
                Sin El Protocolo del Retorno
              </div>
              <div className="p-4 md:p-6 font-playfair text-miel-red font-bold text-sm md:text-lg text-center" data-id="element-22">
                Costo real
              </div>
            </div>

            <div className="divide-y divide-miel-crimson/10" data-id="element-23">
              {costs.map((item, i) => <div key={i} className="grid grid-cols-2 hover:bg-miel-darker/50 transition-colors" data-id="element-24">
                  <div className="p-4 md:p-6 text-sm md:text-base text-miel-cream/70 border-r border-miel-crimson/10 flex items-center" data-id="element-25">
                    <span className="mr-2 text-miel-cream/30" data-id="element-26">•</span>{' '}
                    {item.without}
                  </div>
                  <div className="p-4 md:p-6 text-sm md:text-base text-miel-cream/90 font-medium flex items-center" data-id="element-27">
                    <span className="mr-2 text-miel-red" data-id="element-28">→</span> {item.cost}
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-29">
          <div className="text-center" data-id="element-30">
            <p className="text-xl md:text-2xl text-miel-cream mb-4" data-id="element-31">
              La próxima noche puede ser diferente.
            </p>
            <p className="font-playfair text-2xl md:text-4xl text-miel-gold italic" data-id="element-32">
              "La próxima noche puede ser la noche en que él escriba." 🕯️
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}